import styles from '@uuhsc/cores-app-library/styles/drawer.module.css';
import { OpenDetailsButton } from 'Components/Buttons';
import { SITE_PAGES } from 'Config';
import { useDrawerContext } from 'Context';
import BiobankDetailsView from 'Pages/Biobanks/BiobankDetailsView';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
import { isUserAuthorized } from 'Util';

const BiobankDrawerButton = ({
  biobankId,
  label,
  drawerTitle,
  linkToDetailId,
  ...props
}) => {
  const navigate = useNavigate();
  const { openDrawer, closeDrawer } = useDrawerContext();

  const onClickForDetail = () => {
    closeDrawer();
    navigate(`${SITE_PAGES.BIOBANK_DETAIL.path}/${biobankId}`);
  };

  const drawerHeader =
    linkToDetailId &&
    isUserAuthorized(SITE_PAGES.BIOBANK_DETAIL.requiredAuth) ? (
      <>
        {drawerTitle || label}
        <OpenDetailsButton
          tooltipText='Click to manage bio resource entry'
          onClick={onClickForDetail}
        />
      </>
    ) : (
      drawerTitle || label
    );

  let drawerContent = biobankId != null && (
    <BiobankDetailsView {...props} biobankId={biobankId} />
  );
  const onClick = () => {
    openDrawer({
      content: drawerContent,
      title: drawerHeader,
      size: { defaultWidth: 680, minWidth: 580 },
    });
  };

  return (
    label && (
      <span className={styles.drawer_button_text} onClick={onClick}>
        {label}
      </span>
    )
  );
};

BiobankDrawerButton.propTypes = {
  biobankId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  drawerTitle: PropTypes.string,
  linkToDetailId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default BiobankDrawerButton;
